import { isNote } from '@/utils/categUtils';
import { isObjectEmpty } from '@/utils/comparisonUtils';

/**
 * Update, add or remove filter from filter string
 * @param {string} filterString The source filter string
 * @param {string} nameId The filter name (ex: millesime, couleur)
 * @param {string} valueId The filter valueId (ex: 29 for millesime, 5 for couleur)
 * @param {boolean} check True if filter must be set, false to remove it
 * @return {string} the new filter string
*/
export const updateFilterString = (filterString, nameId, valueId, check) => {
  // Build a key/value object from the given filters string
  // Before: "filter1:v1|filter2:v2|filter3:v3|note_rp:88|note_rp:88+|note_rp:89"
  // After: { filter1: v1, filter2: v2, filter3: v3, note_rp: [note_rp:88, note_rp:88+, note_rp:89]}
  let filters = filterString.split('|').reduce((obj, item) => {
    const [key, value] = item.split(':');
    // Verify if there is already a filter for critics
    if (isNote(filterString) && isNote(key)) {
      // Need special case if the first iteration
      if (isObjectEmpty(obj)) {
        return { [key]: [`${key}:${value}`] };
      } else {
        // Create array with structure : [note_rp:88, note_rp:88+, note_rp:89]
        return { ...obj, [key]: Array.isArray(obj[key]) ? [...obj[key], `${key}:${value}`] : [obj[key], `${key}:${value}`] };
      }
    } else {
      return { ...obj, [key]: value };
    }
  }, {});

  // Add or overwrite the requested filter entry
  filters[nameId] = check ? (
    isNote(nameId) ? valueId.join('|' + nameId + ':') : valueId
  ) : undefined;

  if (isNote(nameId) && !check) {
    filters = Object.fromEntries(Object.entries(filters).filter(([key]) => !isNote(key)));
  }

  // Rebuild the filters string
  filters = Object.keys(filters).filter((k) => (!!filters[k] || filters[k] === 0)).reduce((arr, k) => [
    ...arr,
    isNote(k) && Array.isArray(filters[k]) ? filters[k].join('|') : `${k}:${filters[k]}` // Need join notes Tab before join all filters
  ], []).join('|');

  return filters.replace('||', '|');
};
